import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcResources = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M20.949 12.014a1 1 0 0 1-.632 1.265l-8 2.67a1 1 0 0 1-.633 0l-5-1.667a1 1 0 0 1 .632-1.897L12 13.945l7.684-2.563a1 1 0 0 1 1.265.632Z",
  fill: "var(--mds-nav-icon-weak)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M12.316 3.551a1 1 0 0 0-.632 0L3.709 6.21A2.5 2.5 0 0 0 2 8.581V10.5c0 .404.06 1.041.406 1.682A2.344 2.344 0 0 0 2 13.5v.838a4 4 0 0 0 2.735 3.795l6.949 2.316a1 1 0 0 0 .632 0l8.5-2.834a1 1 0 1 0-.632-1.897L12 18.446l-6.632-2.21A2 2 0 0 1 4 14.337V13.5a1 1 0 0 0 .582-1.813C4.073 11.323 4 10.849 4 10.5V8.887l7.684 2.562a1 1 0 0 0 .632 0l8.289-2.763c1.14-.38 1.14-1.992 0-2.372l-8.289-2.763Z",
  fill: "var(--mds-nav-icon-accent)"
})), "IcResources");

export { IcResources };
//# sourceMappingURL=ic-resources.js.map
